import React, {Component} from 'react'
import {Link} from 'react-router'

import BG1 from '../images/list-bg1.jpg'
import BG3 from '../images/list-bg3.jpg'
import BG4 from '../images/list-bg4.jpg'
import DraftPhoto from '../images/draft.jpg'
import PP from '../images/pp.jpg'
import PPPET from '../images/pppet.jpg'
import PE from '../images/pe.jpg'
import Icon1BG from '../images/icon1.jpg'
import Icon2BG from '../images/icon2.jpg'
import Icon3BG from '../images/icon3.jpg'
import Icon4BG from '../images/icon4.jpg'

const Jeyu = {
  photo1: {
    backgroundImage:'url('+BG1+')',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    alignItems: 'center',
  },
  photo2: {
    background: '#fff'
  },
  photo3: {
    backgroundImage:'url('+BG3+')',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    alignItems: 'center',
  },
  photo4: {
    backgroundImage:'url('+BG4+')',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    padding: '60px 0 70px',
    height: 430
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  H2white: {
    color: '#fff',
    fontWeight: 400,
    fontSize: 34
  },
  Pwhite: {
    margin: 0,
    color: '#fff',
    fontWeight: 100
  },
  H2: {
    color: '#014852',
    fontSize: 34,
    fontWeight: 400
  },
  iconh2: {
    fontSize: 25,
    margin : '20px 0 0 0',
    fontWeight: 200
  },
  h3: {
    color: '#014852',
    fontSize: 25,
    fontWeight: 100
  },
  P:{
    color: '#555',
    fontWeight: 100
  },
  iconp: {
    fontWeight: 100,
    margin: 0
  },
  Pheight: {
    height: 70,
    color: '#555',
    fontWeight: 100
  },
  Pmb: {
    color: '#555',
    marginBottom: 50,
    fontWeight: 100
  },
  draftBox: {
    backgroundImage: ('url('+DraftPhoto+')'),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    width: '100%',
    height: 430,
    textAlign: 'center'
  },
  center: {
    textAlign: 'center',
    fontWeight: 100
  },
  HasPa: {
    padding: '50px 0'
  },
  box: {
    borderTop: '1px solid  #ccc',
    padding: '10px 0'
  },
  ppPhotoBox: {
    backgroundImage: 'url('+PP+')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 225
  },
  pppetPhotoBox: {
    backgroundImage: 'url('+PPPET+')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 225
  },
  pePhotoBox: {
    backgroundImage: 'url('+PE+')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 225
  },
  whitebg: {
    background: '#fff'
  },
  pdleft: {
    paddingLeft: 16
  },
  hasBorder: {
    border: '1px solid rgb(204,204,204)',
    padding: '2px 30px',
    borderRadius: 7,
    margin: '20px 0 70px'
  },
  contact: {
    color: 'rgb(255, 171, 18)',
    fontWeight: 400,
    paddingLeft: 6
  },
  iconBox1: {
    backgroundImage: 'url('+Icon1BG+')',
    backgroundSize: 'contain',
    width: 115,
    height: 70,
    margin: '60px auto 10px'
  },
  iconBox2: {
    backgroundImage: 'url('+Icon2BG+')',
    backgroundSize: 'contain',
    width: 115,
    height: 70,
    margin: '60px auto 10px'
  },
  iconBox3: {
    backgroundImage: 'url('+Icon3BG+')',
    backgroundSize: 'contain',
    width: 115,
    height: 70,
    margin: '60px auto 10px'
  },
  iconBox4: {
    backgroundImage: 'url('+Icon4BG+')',
    backgroundSize: 'contain',
    width: 115,
    height: 70,
    margin: '60px auto 10px'
  }
}

class ListA extends Component {
  render() {
    return(
      <div className="container-fluid">
       <div className="row" style={Jeyu.photo1}>
        <div className="container">
         <div className="row">
          <div className="xs-12 sm-12 md-6 lg-6">
           <div style={Jeyu.flex}>
            <h2 style={Jeyu.H2white}>傳統紡織工業再升級</h2>
            <p style={Jeyu.Pwhite}>
            台灣的紡織業，在1965-1990年代是台灣經濟的主流，創造了經濟奇蹟…<br />
            為了能使生活品質提高，尤其對生活環境的保護，我們不斷研發、創新，使用天然材料來平衡生態環境。無論用於紡織類、養殖家畜類、種植蔬果菜類的生態鏈中，來提升環保機能，去除化學肥料、農藥等生態危害。
            </p>
          </div>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

class ListB extends Component {
  render() {
    return(
      <div className="container-fluid">
       <div className="row" style={Jeyu.photo2}>
        <div className="container">
         <div className="row">
          <div className="xs-12 sm-12 md-6 lg-6">
            <div style={Jeyu.draftBox}></div>
          </div>
          <div className="xs-12 sm-12 md-6 lg-6">
           <div style={Jeyu.flex}>
            <h2 style={Jeyu.H2}>全球獨家長效型機能纖維</h2>
            <p style={Jeyu.P}>
               防蚊蟲polyester纖維，是為長效型纖維，無毒、無味、環保之世界首創纖維，可讓人類免於蟲害困擾。其功效能防蚊、跳蚤、螞蟻、臭蟲、蒼蠅等防護效果。此纖維可用於各種產品上，如:蚊帳、寢具、紗窗紗網、農用地膜等。在兼顧使用安全與產品成效的前提之下，依照使用範圍、領域調配出不同的濃度配方成品，創造產品最大效益。
            </p>
          </div>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

class ListC extends Component {
  render() {
    return(
      <div className="container-fluid">
       <div className="row" style={Jeyu.photo3}>
        <div className="container">
         <div className="row">
          <div className="xs-12 sm-12 md-6 lg-6">
           <div style={Jeyu.flex}>
            <h2 style={Jeyu.H2}>被動性的安全防護網</h2>
            <p style={Jeyu.P}>
            市面銷售的殺蟲劑侵入性的噴灑，會誤殺其它沒有危害的生物昆蟲，破壞生態平衡。JeyuTex除蟲布料是被動性的保護屏障。只有當害蟲接近而接觸到網面才會被滅除，只防該防的蟲，確保其它生物的生存安全，降低對生態系統最低的傷害。
            </p>
          </div>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

class ListD extends Component {
  render() {
    return(
      <div className="container-fluid">
       <div className="row" style={Jeyu.photo4}>
        <div className="container">
         <div className="row">
          <div className="xs-12 sm-12 md-offset-6 md-6 lg-offset-6 lg-6">
           <div style={Jeyu.flex}>
            <h2 style={Jeyu.H2white}>通過SDS化學品安全檢測</h2>
            <p style={Jeyu.Pwhite}>
            採用奈米製程，將氯菊酯嵌入原料之中，一旦蚊蟲接觸到JeyuTex除蟲布料，其神經系統將受干擾損壞，進而喪失行動能力。符合世界衛生組織WHO標準，為當前市面上最安全的除蟲藥劑之一。
            此外，我們所擁有的鑲嵌技術，能夠使產品表面的藥劑在被洗掉或磨損後，依舊能透過產品內部的儲存量遞補釋放到表面，維持長期的防蟲功效。
            </p>
          </div>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

class ListE extends Component {
  render() {
    return(
      <div className="container-fluid" style={Jeyu.whitebg}>
      <div className="row">
       <div className="container">
        <div className="row" style={Jeyu.HasPa}>
         <div style={Jeyu.center}>
          <h2 style={Jeyu.H2}>為地球及人類盡一份心力</h2>
          <p style={Jeyu.Pmb}>全球獨家機能性纖維紗，以保護環境為出發點<br />
           研發出各種除蟲紗網(PE/PP/PET)，可用於不同領域<br />
           通過SDS檢測，對人體無害，請安心使用</p>
         </div>
         <div style={Jeyu.box}>
          <p style={Jeyu.pdleft}>除蟲紗網介紹</p>
          <div className="container-fluid">
           <div className="row">
            <div className="xs-12 sm-6 md-4  lg-4">
             <h3 style={Jeyu.h3}>1. PP</h3>
             <p style={Jeyu.Pheight}>聚丙烯(Polypropylene)</p>
             <div style={Jeyu.ppPhotoBox}></div>
             <p style={Jeyu.P}>
                 布料質量輕、彈性高、密度小、柔軟易變形，適合撲滅塵螨，可用於寢具、蚊帳、衣物等，材質容易分解，成本較高。
             </p>
            </div>
            <div className="xs-12 sm-6 md-4  lg-4">
             <h3 style={Jeyu.h3}>2. PP+PET</h3>
             <p style={Jeyu.Pheight}>聚丙烯(Polypropylene)+聚對苯二甲酸乙二酯(polyethylene terephthalate)</p>
             <div style={Jeyu.pppetPhotoBox}></div>
             <p style={Jeyu.P}>
                 布料質量輕、韌性佳，適合防蚊蟲、塵螨等小型截肢類害蟲，可用於寢具、蚊帳、衣物、濾網、紗窗等，材質容易分解。
             </p>
            </div>
            <div className="xs-12 sm-6 md-4  lg-4">
             <h3 style={Jeyu.h3}>3. PE</h3>
             <p style={Jeyu.Pheight}>聚乙烯(polyethylene)</p>
             <div style={Jeyu.pePhotoBox}></div>
             <p style={Jeyu.P}>
                 布料材質較硬挺，無彈性、密度較大，適合防蚊蟲、塵螨等小型截肢類害蟲，可用於紗窗、濾網、帳篷，材質不易分解，較不環保。
             </p>
            </div>
           </div>
          </div>
         </div>
         <div style={Jeyu.flexBox}>
          <div style={Jeyu.hasBorder}>
           <p style={Jeyu.center}>
            以上為布料示意圖，又可分為平織網、針織網，<br />
            可依據客戶需求客製化或改變藥劑量(WHO標準範圍內)，更多需求請直接<Link to="/Contact" style={Jeyu.contact}>聯絡我們</Link>
            </p>
          </div>
         </div>
         <div style={Jeyu.box}>
          <p style={Jeyu.pdleft}>除蟲紗網應用範圍</p>
          <div className="container-fluid">
           <div className="row">
            <div className="xs-12 sm-6 md-3  lg-3">
             <div style={Jeyu.iconBox1}></div>
             <div style={Jeyu.center}>
              <h2 style={Jeyu.iconh2}>戶外應用</h2>
              <p style={Jeyu.iconp}>抵制害蟲 盡興遊玩</p>
             </div>
             <p style={Jeyu.P}>
                 許多戶外活動愛好者在野外深受蚊蟲困擾而無法盡興，JeyuTex布料能有效防護蚊蟲。可結合使用於帳篷、炊事帳、睡袋、床包、頭套等用具，提供全方位的保護。
             </p>
            </div>
            <div className="xs-12 sm-6 md-3  lg-3">
             <div style={Jeyu.iconBox2}></div>
             <div style={Jeyu.center}>
              <h2 style={Jeyu.iconh2}>衣料應用</h2>
              <p style={Jeyu.iconp}>阻隔蚊蟲 安全防護</p>
             </div>
             <p style={Jeyu.P}>
                 防蚊蟲polyester纖維，是為長效型纖維，無毒、無味、環保之世界首創生產的衣料纖維，可讓人類免於蟲害困擾。其產品功效能防蚊、跳蚤、螞蟻、臭蟲、蒼蠅等防護效果。
             </p>
            </div>
            <div className="xs-12 sm-6 md-3  lg-3">
             <div style={Jeyu.iconBox3}></div>
             <div style={Jeyu.center}>
              <h2 style={Jeyu.iconh2}>家居應用</h2>
              <p style={Jeyu.iconp}>消滅塵瞞 健康生活</p>
             </div>
             <p style={Jeyu.P}>
                 您是否曾經一覺醒來感覺全身奇癢難耐？JeyuTex布料能有效抑制塵蹣身長，趨避臭蟲，減少生活中過敏原。此外，本產品手感柔軟，多次水洗後仍保持功效，給您安心好眠。
             </p>
            </div>
            <div className="xs-12 sm-6 md-3  lg-3">
             <div style={Jeyu.iconBox4}></div>
             <div style={Jeyu.center}>
              <h2 style={Jeyu.iconh2}>農業應用</h2>
              <p style={Jeyu.iconp}>取代農藥 食在安心</p>
             </div>
             <p style={Jeyu.P}>
                 一般農業都過量使用化學肥料及農藥，以致土壤嚴重汙染，農藥殘留過多，影響環境生態及身體健康。我們秉持改善環境生態，推出農業用的防蟲防草地膜，提供農業種植使用。
             </p>
            </div>
           </div>
          </div>
         </div>
        </div>
       </div>
       </div>
      </div>
    )
  }
}

export default class Introduce extends Component {
  render() {
    return(
      <div>
       <ListA />
       <ListB />
       <ListC />
       <ListD />
       <ListE />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Introduce.js